import { EntityServiceRequestError } from '../Services/EntityService';
import ToastManager from '@cb/solaris-react/Utility/ToastManager';
import { AbortType, FetchClientError } from '@cb/common-ts/FetchClient';
import { GqlError } from '@cb/common-ts/GqlClient';
export default class ErrorUtils {
    static handleResponse = (response) => {
        this.handleError(new Error(`[Error ${response.status}] ${response.statusText}}`));
    };
    static handleError = (error, errorMessage = 'An unknown error occurred.', onNotUnmount) => {
        if (ErrorUtils.isUnmount(error)) {
            return;
        }
        else if (error instanceof GqlError) {
            if (error.errors.length) {
                errorMessage = error.errors
                    .map((e) => `[GraphQL error at ${e.path?.join('.')}]: ${e.message}`)
                    .join(' ');
            }
            else if (error.message) {
                errorMessage = error.message;
            }
        }
        else if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
            errorMessage = error.message;
        }
        else {
            console.error('Unknown error type', error);
        }
        ToastManager.showError({
            text: errorMessage,
            autoCloseMs: errorMessage.length > 100 ? undefined : 3000,
        });
        if (onNotUnmount && !ErrorUtils.isUnmount(error)) {
            onNotUnmount();
        }
    };
    static isUnmount = (error) => {
        if (error instanceof EntityServiceRequestError) {
            return error.type === AbortType.UNMOUNT;
        }
        if (error instanceof FetchClientError) {
            return error.abortType === AbortType.UNMOUNT;
        }
        if (error instanceof DOMException) {
            return error.code === DOMException.ABORT_ERR || error.name === 'AbortError';
        }
        return false;
    };
}
//# sourceMappingURL=ErrorUtils.js.map